import MatchType from "./MatchType";
import FootballStatus from "./FootballStatus";
import BasketballStatus from "./BasketballStatus";

export default class Match {
    id = null;
    competition_id = null;
    competition_logo = null;
    status_id = 0;
    match_time = 0;
    home_name = null;
    home_log = null;
    away_name = null;
    away_log = null;
    competition_name = null;
    short_name_zh = null;
    home_scores = [];
    away_scores = [];
    host = [];
    type_id = MatchType.FOOTBALL;
    is_hot = 0;
    home_team_id = 0;
    away_team_id = 0;
    nami = [];
    groupId = '';

    constructor(match) {
        this.id = match.id;
        this.competition_id = match.competition_id;
        this.competition_logo = match.competition_logo;
        this.status_id = match.status_id;
        this.match_time = match.match_time;
        this.home_name = match.home_name;
        this.home_log = match.home_log;
        this.away_name = match.away_name;
        this.away_log = match.away_log;
        this.competition_name = match.competition_name;
        this.short_name_zh = match.short_name_zh;
        this.home_scores = match.home_scores;
        this.away_scores = match.away_scores;
        this.host = match.host;
        this.type_id = match.type_id;
        this.is_hot = match.is_hot;
        this.home_team_id = match.home_team_id;
        this.away_team_id = match.away_team_id;
        this.groupId = match.groupId;
        this.nami = match.nami;
    }

    living() {
        if (this.type_id == MatchType.FOOTBALL) {
            return this.status_id > FootballStatus.NOT_START && this.status_id < FootballStatus.FINISH;
        }
        if (this.type_id == MatchType.BASKETBALL) {
            return this.status_id > BasketballStatus.NOT_START && this.status_id < BasketballStatus.FINISH;
        }
        return false;
    }

    notFinished() {
        if (this.type_id == MatchType.FOOTBALL) {
            return this.status_id > FootballStatus.ERROR && this.status_id < FootballStatus.FINISH;
        }
        if (this.type_id == MatchType.BASKETBALL) {
            return this.status_id > BasketballStatus.ERROR && this.status_id < BasketballStatus.FINISH;
        }
    }

    notStarted() {
        if (this.type_id == MatchType.FOOTBALL) {
            return this.status_id == FootballStatus.NOT_START;
        }
        if (this.type_id == MatchType.BASKETBALL) {
            return this.status_id == BasketballStatus.NOT_START;
        }
    }

    finished() {
        if (this.type_id == MatchType.FOOTBALL) {
            return this.status_id == FootballStatus.FINISH;
        }
        if (this.type_id == MatchType.BASKETBALL) {
            return this.status_id == BasketballStatus.FINISH;
        }
    }

    getHalfScore() {
        let halfHome = 0;
        let halfAway = 0;
        if (this.home_scores && this.home_scores[1]) {
            halfHome = this.home_scores[1];
        }
        if (this.away_scores && this.away_scores[1]) {
            halfAway = this.away_scores[1];
        }
        return '半' + halfHome + ':' + halfAway;
    }

    getCornerScore() {
        let homeCorner = this.home_scores && this.home_scores[4] ? this.home_scores[4] : -1;
        let awayCorner = this.away_scores && this.away_scores[4] ? this.away_scores[4] : -1;
        if (homeCorner < 0 || awayCorner < 0) {
            return "角0:0";
        }
        return '角' + homeCorner + ':' + awayCorner;
    }

    getHomeScore() {
        if (this.type_id == MatchType.FOOTBALL) {
            if (this.status_id == FootballStatus.NOT_START
                || this.status_id == FootballStatus.CANCELED
                || this.status_id == FootballStatus.DETERMINED
                || this.status_id == FootballStatus.PUT_OFF) {
                return '';
            }
            return this.home_scores && this.home_scores[0] ? this.home_scores[0] : '0';
        } else if (this.type_id == MatchType.BASKETBALL) {
            if (this.status_id == BasketballStatus.NOT_START
                || this.status_id == BasketballStatus.PUT_OFF
                || this.status_id == BasketballStatus.DETERMINED
                || this.status_id == BasketballStatus.CANCELED) {
                return '';
            }
            let sum = 0;
            if (this.home_scores) {
                for (let i = 0; i < this.home_scores.length; i++) {
                    let num = Number(this.home_scores[i]);
                    if (!isNaN(num)) {
                        sum += num;
                    }
                }
            }
            return sum;
        }
        return 0;
    }

    getAwayScore() {
        if (this.type_id == MatchType.FOOTBALL) {
            if (this.status_id == FootballStatus.NOT_START
                || this.status_id == FootballStatus.CANCELED
                || this.status_id == FootballStatus.DETERMINED
                || this.status_id == FootballStatus.PUT_OFF) {
                return '';
            }
            return this.away_scores && this.away_scores[0] ? this.away_scores[0] : '0';
        } else if (this.type_id == MatchType.BASKETBALL) {
            if (this.status_id == BasketballStatus.NOT_START
                || this.status_id == BasketballStatus.PUT_OFF
                || this.status_id == BasketballStatus.DETERMINED
                || this.status_id == BasketballStatus.CANCELED) {
                return '';
            }
            let sum = 0;
            if (this.away_scores) {
                for (let i = 0; i < this.away_scores.length; i++) {
                    let num = Number(this.away_scores[i]);
                    if (!isNaN(num)) {
                        sum += num;
                    }
                }
            }
            return sum;
        }
        return 0;
    }

    getStatus() {
        if (this.type_id == MatchType.FOOTBALL) {
            return FootballStatus.getStatus(this.status_id);
        }
        return BasketballStatus.getStatus(this.status_id);
    }

    getVs() {
        if (this.type_id == MatchType.FOOTBALL) {
            if (this.status_id >= FootballStatus.FIRST_HALF && this.status_id <= FootballStatus.FINISH) {
                return this.getHomeScore() + ' - ' + this.getAwayScore();
            }
        } else if (this.type_id == MatchType.BASKETBALL) {
            if (this.status_id >= BasketballStatus.PART_1 && this.status_id <= BasketballStatus.FINISH) {
                return this.getHomeScore() + ' - ' + this.getAwayScore();
            }
        }
        return 'VS';
    }

    getScoreVs() {
        if (this.type_id == MatchType.FOOTBALL) {
            if (this.status_id >= FootballStatus.FIRST_HALF && this.status_id <= FootballStatus.FINISH) {
                let halfHomeScore = this.getHalfScore();
                let halfAwayScore = this.getCornerScore();
                return halfHomeScore + '    ' + halfAwayScore;
            }
        } else if (this.type_id == MatchType.BASKETBALL) {
            if (this.status_id >= BasketballStatus.PART_1 && this.status_id <= BasketballStatus.FINISH) {
                let homeScore = Number(this.getHomeScore());
                let awayScore = Number(this.getAwayScore());
                homeScore = isNaN(homeScore) ? 0 : homeScore;
                awayScore = isNaN(awayScore) ? 0 : awayScore;
                return '分差:' + (homeScore - awayScore) + '  总分:' + (homeScore + awayScore)
            }
        }
        return '';
    }

    showScore() {
        if (this.type_id == MatchType.FOOTBALL) {
            if (this.status_id >= FootballStatus.FIRST_HALF && this.status_id <= FootballStatus.FINISH) {
                return true;
            }
        } else if (this.type_id == MatchType.BASKETBALL) {
            if (this.status_id >= BasketballStatus.PART_1 && this.status_id <= BasketballStatus.FINISH) {
                return true;
            }
        }
    }
}
